import {StyleSheet} from 'react-native';

import {alto} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  container: {flexGrow: 1},

  svgContainer: {
    fontSize: 12,
    paddingBottom: 0,
    bottom: -12,
    fill: alto,
  },
});
